<div class="app-container" dir="rtl">
  <header class="app-header">
    <div class="header-title">خطاهای ECU</div>

    <button class="back-btn" onclick="window.history.back()">
      <span>بازگشت</span>
      <span class="arrow">←</span>
    </button>
  </header>

  <!-- dtc-errors.component.html -->
  <div class="dtc-container">
    <div class="cards-wrapper">
      <div
        class="error-card"
        *ngFor="let error of data"
        [ngClass]="{
          'severity-high': error.strSeverity === 'High',
          'severity-unknown': error.iOBD_DTCDictinary === -1
        }"
      >
        <div class="card-header">
          <div class="code-badge">
            <i class="fa fa-code"></i>
            <span class="code-text">{{ error.strCode }}</span>
          </div>
          <div class="severity-badge" *ngIf="error.strSeverity">
            <i class="fa fa-warning"></i>
            <span>{{
              error.strSeverity === "High" ? "بحرانی" : error.strSeverity
            }}</span>
          </div>
          <div class="unknown-badge" *ngIf="error.iOBD_DTCDictinary === -1">
            <i class="fa fa-question-circle"></i>
            <span>ناشناخته</span>
          </div>
        </div>

        <div class="card-body">
          <h3 class="error-title">
            <i class="fa fa-info-circle"></i>
            {{ error.strTitle }}
          </h3>

          <div class="error-description">
            <p>{{ error.strDescription }}</p>
          </div>

          <div class="error-advice" *ngIf="error.strAdvice">
            <div class="advice-header">
              <i class="fa fa-lightbulb-o"></i>
              <span>راهکار پیشنهادی</span>
            </div>
            <p>{{ error.strAdvice }}</p>
          </div>
        </div>

        <div class="card-footer">
          <button class="action-btn primary" (click)="shareError(error)">
           <i class="fa fa-clipboard"></i>
           کپی‌ کردن
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
